var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.attributes),function(attribute,idx){return _c('sidebar-checkbox-filter',_vm._b({key:idx},'sidebar-checkbox-filter',attribute,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }